"use client";

import React from "react";
import Image from "next/image";
import { useQuery } from "@tanstack/react-query";
import { getRandomBackgroundImage } from "@/hooks/background-images/backgroundImagesApi";

export const RotatingBackground: React.FC = () => {
  const { data } = useQuery({
    queryKey: ["backgroundImage"],
    queryFn: getRandomBackgroundImage,
    refetchInterval: 300000,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return (
    <div className="z-[-1] fixed inset-0 overflow-hidden" data-dashboard-background>
      {!data?.url ? (
        <div className="absolute inset-0 bg-primary-900/80" />
      ) : (
        <Image
          src={data.url}
          alt=""
          fill
          priority
          quality={90}
          className="object-cover transition-opacity duration-1000 ease-in-out"
          style={{
            opacity: 1,
          }}
        />
      )}
    </div>
  );
};
